
export default function PercentBar(props: {percent: number}) {
    return (
        <div style={{width: '100%', height: '10px', backgroundColor: 'grey', borderRadius: '5px'}}>
            <div style={{width: props.percent + '%', height: '10px', backgroundColor: '#68e5e8', borderRadius: '5px'}}></div>
        </div>
    );
}